/**
 *
 * @module active-sponsorship
 * @author Greg Babula [greg.babula@mlb.com]
 * @description Identifying the active browser tab and sending in a DFP ad request
 * @returns {Object}
 *
 */

define('active-sponsorship/active-sponsorship',['require','exports','module','scrollMonitor/scrollMonitor','bam-visibly/visibly'],function(require, module, exports) {

    'use strict';

    var scrollMonitor   = require('scrollMonitor/scrollMonitor');
    var visibly         = require('bam-visibly/visibly');

    var d = document,
        w = window,
        w_visibly_events = false,
        w_tab_state = 'hidden',
        w_tab_visible = 'false';

    /**
     *
     * @function _watchWindow
     * @description attaches visibly events, stores window/tab state in cache
     *
     */
    function _watchWindow() {

        /**
         *
         * @event visibilitychange
         * @param {String} state
         *
         */
        visibly.visibilitychange(function(state) {

            w_tab_state = state;
            w_tab_visible = (!visibly.hidden()).toString();

        });

        // global events attached, keep track
        // to ensure we only do this once
        w_visibly_events = true;

    }

    /**
     *
     * @function _isElementVisible
     * @description determines if element is visible in viewport
     * @param {Element} element ID string
     * @returns {String} _elementVisible
     *
     */
    function _isElementVisible(element) {

        var _watcher = scrollMonitor.create(element),
            _elementTopVisible = _watcher.top + (_watcher.height / 2) >= scrollMonitor.viewportTop,
            _elementBottomVisible = _watcher.bottom - (_watcher.height / 2) <= scrollMonitor.viewportBottom,
            _elementInViewport = _watcher.isInViewport && (_elementTopVisible && _elementBottomVisible);

        // remove watcher and clear out its event listeners
        // at this point we already know if the element is
        // in the viewport, so we dont need this extra overhead,
        // the function will be called again the next time we need this
        // information
        _watcher.destroy();

        return _elementInViewport.toString();

    }

    /**
     *
     * @function adSlotTargeting
     * @param {String} element ID string
     * @description returns targeting object based on element and tab visibility
     * @note using getElementById for speed, but also because ADs are always required to
     * be unique ID's
     * @returns {Object}
     *
     */
    function adSlotTargeting(element) {

        var _element = d.getElementById(element);

        // check if visibly events have been attached
        if (!w_visibly_events) {

            _watchWindow();

        }

        // only return a targeting object if the element 
        // exists in the current document
        if (_element) {

            return {
                'tabvisible': w_tab_visible,
                'inviewport': _isElementVisible(_element)
            };

        }

    }

    return {
        adSlotTargeting: adSlotTargeting,
        tabState: w_tab_state,
        tabVisible: w_tab_visible
    };

});

